<template>
  <p class="sword-help-text-wuk" v-show="text">
    <span>
      {{ text }}
    </span>
  </p>
</template>

<script>
export default {
  name: 'HelpText',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
  .sword-help-text-wuk {
    @include input-footer-wrapper-wuk;
    color: $help-text-color-wuk;
  }
</style>
